module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020-desktop/0013.jpg?v=9fc4858e";